import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  signal,
  inject,
} from '@angular/core';

import {
  AlertsComponent,
  AlertsService,
  PrimengButtonDirective,
  SpinnerComponent,
} from '@web/shared/ui';
import { FormTitleWithSubtitleComponent } from '../../ui/form-title-with-subtitle/form-title-with-subtitle.component';
import { finalize } from 'rxjs';
import { once } from '@web/utils';
import { Button } from 'primeng/button';
import { SignUpService } from '../../services/sign-up.service';

@Component({
  selector: 'app-activate-account',
  imports: [
    FormTitleWithSubtitleComponent,
    AlertsComponent,
    SpinnerComponent,
    Button,
    PrimengButtonDirective,
  ],
  templateUrl: './activate-account.component.html',
  styleUrl: './activate-account.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class ActivateAccountComponent implements OnInit {
  private readonly alerts = inject(AlertsService);
  private readonly signUp = inject(SignUpService);

  public readonly token = input.required<string>();
  public readonly navigateToSignInPageEvent = output<void>();

  protected readonly isAlertVisible = signal<boolean>(false);

  public ngOnInit(): void {
    this.activate();
  }

  public handleNavigateToSignInPageClick(): void {
    this.navigateToSignInPageEvent.emit();
  }

  private activate(): void {
    this.signUp
      .activate(this.token())
      .pipe(
        once(),
        finalize(() => this.markAlertAsVisible()),
      )
      .subscribe({
        next: () => this.showSuccessAlert(),
        error: () => this.showFailureAlert(),
      });
  }

  private showSuccessAlert(): void {
    this.alerts.showSingle((builder) =>
      builder
        .initSuccess(
          'Twoje konto zostało pomyślnie aktywowane. Możesz teraz się zalogować.',
        )
        .closeable(false)
        .build(),
    );
  }

  private showFailureAlert(): void {
    this.alerts.showSingle((builder) =>
      builder
        .initFailure(
          'Nie udało się aktywować konta. Link aktywacyjny jest nieprawidłowy lub wygasł. Proszę skontaktować się z administratorem w celu uzyskania pomocy.',
        )
        .closeable(false)
        .build(),
    );
  }

  private markAlertAsVisible(): void {
    this.isAlertVisible.set(true);
  }
}
